var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1377 0.325198C6.05919 0.321446 0.967875 4.99182 0.363281 11.1239H8.58856V9.32228C8.58856 8.99361 8.85423 8.72422 9.17836 8.72422H15.0985C15.4263 8.72422 15.6883 8.99361 15.6883 9.32603V15.3253C15.6883 15.654 15.4263 15.9234 15.0985 15.9234H9.17836C8.85053 15.9234 8.58856 15.654 8.58856 15.3253V13.5237H0.363281C1.0182 20.121 6.81918 24.928 13.321 24.2639C19.8272 23.6036 24.5677 17.7176 23.9128 11.1247C23.3075 4.99257 18.2162 0.325948 12.1384 0.325948L12.1377 0.325198Z",
    fill: "#A47AFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector (3).7437e14ccff7f9a0e4d1707212d7e4c4.svg";
export { ForwardRef as ReactComponent };